import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import moment from "moment";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";
import TitleCard from "./../Nano/TitleCard.js";
import SocialIconsCard from "./../Nano/SocialIconsCard.js";
// import ListLine from "./../Nano/ListLine.js";

//IMAGES
import { ReactComponent as UpcomingProgrammes } from "../Global/Icons/upcomingProgrammes.svg";

const multiple = nota.global.multiple;

const StyledCountryCard = styled.div`
  width: 100%;

  .asideBlocksWrapper {
    background-color: ${nota.color.neutral.lightGrey};
  }
  /* .asideBlock {
    padding: ${multiple * 2 + "px"};
  } */
  .leftAsideBlock {
    /* padding: 0; */
    background-color: ${nota.color.neutral.white};
    .topBlock {
      padding: ${multiple * 2 + "px"};
      background-color: ${nota.color.secondary.secDarkBlue};
      width: 60%;
      height: auto;
      .titleContainer {
        overflow: unset;
        .titleWrapper {
          margin-bottom: 4px;
          .primaryTitleWrapper {
            overflow: initial;
            display: unset;
            h3 {
              color: ${nota.color.neutral.white};
            }
          }
        }
      }
      .channelWrapper {
        margin: 0;
        p {
          color: ${nota.color.neutral.white};
        }
      }
    }
  }
  .rightAsideBlock {
    background-color: ${nota.color.neutral.lightGrey};
    padding-left: 16px;
  }

  .channelWrapper {
    margin-bottom: ${multiple / 2 + "px"}; /* 4px */
  }
  .listLineWrapper {
    justify-content: center;
    align-items: center;
  }
  .infoWrapper {
    margin: ${multiple + "px"} 0;
  }

  .launchInfoWrapper {
    padding: ${multiple * 2 + "px"};
    background-color: ${(props) => (props.isPreview ? nota.color.main.mOne : nota.color.secondary.secLightBlue)};
    height: auto;
    width: 40%;
    p {
      color: ${nota.color.neutral.white};
      text-transform: uppercase;
      font-size: 12px;
    }
    .bckInfoWrapper {
      height: auto;
      h3 {
        text-align: center;
        color: ${nota.color.neutral.white};
      }
      .icon {
        margin-left: ${multiple + "px"};
        display: ${(props) => (props.isPreview ? `flex` : `none`)};
        width: auto;
        svg {
          width: 20px;
          height: 16px;
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }
  }

  .socialContainer {
    .socialWrapper {
    }
  }
  @media only screen and (max-width: 800px) {
    .asideBlocksWrapper {
      flex-direction: column;
      /* margin-top: 16px; */
      .leftAsideBlock {
        .topBlock {
          justify-content: center;
          padding: 8px 16px;
          .channelWrapper {
            margin-bottom: 0;
            justify-content: center;
          }
        }
        .launchInfoWrapper {
          padding: 8px 16px;
        }
      }
      .rightAsideBlock {
        padding: 8px 16px;
      }
    }
  }
  @media only screen and (max-width: 340px) {
    .asideBlocksWrapper {
      .leftAsideBlock {
        flex-direction: column;
        .topBlock {
          width: 100%;
        }
        .launchInfoWrapper {
          width: 100%;
        }
      }
    }
  }
`;

class CountryCard extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  getPlatformName = () => {
    let name = null;
    switch (this.props.card.idPlatform) {
      case 1:
        name = this.translation.advancedSearch.platforms.TV;
        break;
      case 2:
      case 3:
        name = this.translation.advancedSearch.platforms.Web;
        break;
    }
    return name;
  };

  onClickSearch = (obj) => {
    return window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "SearchFromCard", filter: obj } }));
  };

  render() {
    let hasNumberOfEpisodes = this.props.card.numberOfEpisodes && this.props.card.numberOfEpisodes > 0;
    let hasDuration = this.props.card.duration && this.props.card.duration > 0;

    return (
      <StyledCountryCard className="countryCard" isPreview={this.props.card.isDatePreview}>
        <NanoFlex className="asideBlocksWrapper" flexDirection={"row"}>
          <NanoFlex className="asideBlock leftAsideBlock" alignItems={"stretch"}>
            <NanoFlex className="topBlock" flexDirection={"column"} alignItems={"flex-start"} justifyContent={"flex-start"}>
              <TitleCard title={this.props.card.country} titleClass={"clickableSearch"} handleOnClick={() => this.onClickSearch({ selectedCountries: [this.props.card.idCountry] })} />
              <NanoFlex className="channelWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                <Type.p className="clickableSearch" onClick={() => this.onClickSearch({ selectedBroadcasts: [this.props.card.idChannel] })}>
                  <em>{this.props.card.channel}</em>
                </Type.p>
                <Type.p className="clickableSearch" onClick={() => this.onClickSearch({ selectedPlatforms: [this.props.card.idPlatform === 1 ? 1 : 2] })}>
                  {this.getPlatformName()}
                </Type.p>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="launchInfoWrapper" flexDirection={"column"}>
              <Type.p>{this.translation.card.date}</Type.p>
              <NanoFlex className="bckInfoWrapper" alignItems={"center"}>
                <Type.h3>
                  <b>{this.props.card.date}</b>
                </Type.h3>
                <NanoFlex className="icon" lignItems={"flex-end"} justifyContent={"flex-end"} title={this.translation.navBar.upcomingProgrammes}>
                  <UpcomingProgrammes />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          {(this.props.card.timeslot || this.props.card.timeslotHour || hasNumberOfEpisodes || hasDuration || this.props.card.programmingDetails || this.props.card.facebookPage || this.props.card.twitterPage) && (
            <NanoFlex className="asideBlock rightAsideBlock" flexDirection={"column"}>
              <NanoFlex className="infoWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                <Type.p>
                  <b>{this.props.card.timeslot}</b> {this.props.card.timeslotHour}
                </Type.p>

                {(hasNumberOfEpisodes || hasDuration) && (
                  <Type.p>
                    {hasNumberOfEpisodes ? `${this.props.card.numberOfEpisodes} ${this.translation.card.episodes}` : null}

                    {hasNumberOfEpisodes && hasDuration ? " x " : null}

                    {hasDuration ? `${this.props.card.duration} ${this.translation.card.minutes}` : null}
                  </Type.p>
                )}
                <Type.p className="frequencyWrapper clickableSearch" onClick={() => this.onClickSearch({ selectedFrequencies: [this.props.card.idFrequency] })}>
                  {this.props.card.frequency} {this.props.card.weekdays && `(${this.props.card.weekdays})`}
                </Type.p>
              </NanoFlex>
              {this.props.card.programmingDetails && (
                <NanoFlex className="infoWrapper" flexDirection={"column"} alignItems={"flex-start"}>
                  <Type.p>{this.props.card.programmingDetails}</Type.p>
                </NanoFlex>
              )}
              {(this.props.card.facebookPage || this.props.card.twitterPage) && (
                <NanoFlex className="socialContainer" justifyContent={"flex-end"}>
                  <SocialIconsCard facebookPage={this.props.card.facebookPage} followsFacebook={this.props.card.facebookLikes} twitterPage={this.props.card.twitterPage} followsTwitter={this.props.card.twitterFollowers} />
                </NanoFlex>
              )}
            </NanoFlex>
          )}
        </NanoFlex>
      </StyledCountryCard>
    );
  }
}

// Set default props
CountryCard.defaultProps = {
  card: {},
};

export default CountryCard;

// --- // Documentation // --- //
/*
import CountryCard from './../Micro/CountryCard.js';

<CountryCard />
*/
